import React, { HTMLAttributes } from "react";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import Logo from "@/assets/images/aboutus/logo.svg"
const { useTranslation } = Hooks;
// import store from "store";
const coins = require("@/assets/images/aboutus/coins.svg")

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Diversified: React.FC<Props> = ({ className }) => {
  const t = useTranslation();
  const tradingHtml = () => {
    return (
      <div dangerouslySetInnerHTML={{ __html: t('aboutus.TradingCategories')}} />
    )
  }
  // const {isLogin} = store.user;

  return (
    <div className={cx(styles.diversifyBox, className)}>
      <div className={cx(styles.titleBox, className)}>
       {tradingHtml()}
      </div>
      <div className={cx(styles.diversify, className)}>
        <div>{t("aboutus.platformIntroduce1") }</div>
        <div>{t("aboutus.platformIntroduce2") }</div>
      </div>
      <div className={cx(styles.imgBox, className)} style={{ backgroundImage: `url(${coins})` }}>
        <div className={cx(styles.center, className)}>
          <img src={Logo} />
        </div>
        <div className={cx(`${styles.cointext} ${styles.cointext1}`, className)}>{ t("aboutus.SpotTrading") }</div>
        <div className={cx(`${styles.cointext} ${styles.cointext2}`, className)}>{ t("aboutus.Fiat") }</div>
        <div className={cx(`${styles.cointext} ${styles.cointext3}`, className)}>{ t("aboutus.FuturesTrading") }</div>
        <div className={cx(`${styles.cointext} ${styles.cointext4}`, className)}>{ t("aboutus.FinanceAccount") }</div>
        <div className={cx(`${styles.cointext} ${styles.cointext5}`, className)}>{ t("aboutus.margin") }</div>
        <div className={cx(`${styles.cointext} ${styles.cointext6}`, className)}>{ t("aboutus.Pool") }</div>
      </div>
    </div>
  );
};

export default Diversified;
